<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" :disabled="triggerSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker placeholder="Select Date" v-model="searchDate" :disabled="triggerSearch"
                    :format="getDefaultDateFormat" allowClear />
                </div>

                <div class="m-form-item-wrapper">
                  <label for="account">Account Name / No. Account</label>
                  <a-select placeholder="Choose Account" v-model="account" :disabled="triggerSearch" class="width-full"
                    initialValue="undefined" allowClear>
                    <a-select-option v-for="item in listaccount" :key="item.bank" :value="item.bank">{{ item.bank
                    }}</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label for="currency">Currency</label>
                  <a-select placeholder="Choose Currency" v-model="currency" :disabled="triggerSearch" class="width-full"
                    initialValue="undefined" allowClear>
                    <a-select-option v-for="item in listcurrency" :key="item.currency" :value="item.currency">{{
                      item.currency }}</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" :disabled="triggerSearch" class="width-full"
                    initialValue="delivered" allowClear>
                    <a-select-option v-for="item in getStatus" :key="item.id" :value="item.value">{{ item.label
                    }}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="Overbooking List" :isMonitoring="true" :manifestLink="getManifestLink"
        :dataList="searching" :estimasi="false" :disabledCreateEditLink="false" createLink="AccountMutationCreateKeu"
        :sisaSaldo="false" :informasi="true">
        <template slot="info" slot-scope="data">
          <span class="margin-remove">BKM</span>

          <a-tag v-if="data.source.is_uploaded == '1'" color="green" class="margin-remove"
            style="'width:50%;text-align: center'">File Have Been Uploaded
          </a-tag>
          <a-tag v-else color="grey" class="margin-remove" style="'width:50%;text-align: center'">No File Uploaded
          </a-tag>
        </template>
      </DataList>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "klaimDirektur",
  props: ["prnMenu"],
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      listaccount: [],
      listcurrency: [],
      searchDate: null,
      search: "",
      status: undefined,
      account: undefined,
      currency: undefined,
      triggerSearch: false,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format(this.getStandartFormatDate);
        outputData = _.filter(outputData, { tgl_buat: filter });
      }

      if (this.account) {
        outputData = outputData.filter(
          (obj) =>
            obj.am_from &&
            obj.am_from.toLowerCase().indexOf(self.account.toLowerCase()) >= 0
        );
      }

      if (this.currency) {
        outputData = outputData.filter(
          (obj) =>
            obj.currency &&
            obj.currency.toLowerCase().indexOf(self.currency.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return outputData;
    },
    getManifestLink() {
      if (localStorage.getItem("nvpn") === "/keuangan") {
        return "AccountMutationManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "AccountMutationManifestAcc";
      } else {
        return "AccountMutationManifest";
      }
    },
  },
  created() {
    this.fetchData();
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "account_mutation",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.listaccount = response.data.combo_bank;
          this.listcurrency = response.data.combo_curr;
          _.forEach(response.data.data, (data) => {
            this.dataList.push({
              title: data.am_no+" | "+data.tlc_create,
              subtitle: { deskripsi: data.am_from + "\nTo : " + data.am_to },
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              subdesc: [
                [
                  {
                    label: data.description,
                    value: "",
                  },
                ],
                [
                  {
                    label: "Create Date",
                    value: this.moment(
                      data.create_date,
                      this.getStandartFormatDate
                    ).format(this.getDefaultDateFormat),
                  },
                ],
                [
                  {
                    label: "Value",
                    value: this.formatCurrency(data.currency, data.value),
                  },
                ],
              ],
              is_uploaded: data.upload_status,
              status: data.status,
              id: data.id_am,
              tgl_buat: data.create_dt,
              searchQ:
                data.am_no +" | "+data.tlc_create +
                " " +
                data.am_from +
                " " +
                this.formatCurrency(data.currency, data.value),
              am_from: data.am_from,
              currency: data.currency,
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          let response = Object.assign({}, err.response.data);
          if (response.status == false) {
            this.displayMessageValue("error-other", response.message);
          } else {
            this.displayMessageValue("error", err);
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
